import { render, staticRenderFns } from "./WebhookSelect.vue?vue&type=template&id=87359d22&scoped=true&"
import script from "./WebhookSelect.vue?vue&type=script&lang=ts&"
export * from "./WebhookSelect.vue?vue&type=script&lang=ts&"
import style0 from "./WebhookSelect.vue?vue&type=style&index=0&id=87359d22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87359d22",
  null
  
)

export default component.exports